const SET_CONFIG = 'SET_CONFIG';
const SET_ORIGIN_FIELD_INFOS = 'SET_ORIGIN_FIELD_INFOS';

// User Prefs
const INIT_USER_PREFS = 'INIT_USER_PREFS';

// SQL Filters
const ADD_SQL_FILTER = 'ADD_SQL_FILTER';
const RENAME_SQL_FILTER = 'RENAME_SQL_FILTER';
const REMOVE_SQL_FILTER = 'REMOVE_SQL_FILTER';

const SET_INCIDENT_LIST_COLUMNS_PREFS = 'SET_INCIDENT_LIST_COLUMNS_PREFS';
const SET_INCIDENT_RESOURCE_LIST_COLUMNS_PREFS =
  'SET_INCIDENT_RESOURCE_LIST_COLUMNS_PREFS';
const SET_INCIDENT_REQUEST_LIST_COLUMNS_PREFS =
  'SET_INCIDENT_REQUEST_LIST_COLUMNS_PREFS';
const SET_INCIDENT_EXPERIENCE_LIST_COLUMNS_PREFS =
  'SET_INCIDENT_EXPERIENCE_LIST_COLUMNS_PREFS';
const SET_RESOURCE_LIST_COLUMNS_PREFS = 'SET_RESOURCE_LIST_COLUMNS_PREFS';
const SET_MAP_PREFS = 'SET_MAP_PREFS';

export default {
  SET_CONFIG,
  SET_ORIGIN_FIELD_INFOS,
  INIT_USER_PREFS,
  ADD_SQL_FILTER,
  RENAME_SQL_FILTER,
  REMOVE_SQL_FILTER,
  SET_INCIDENT_LIST_COLUMNS_PREFS,
  SET_INCIDENT_RESOURCE_LIST_COLUMNS_PREFS,
  SET_INCIDENT_REQUEST_LIST_COLUMNS_PREFS,
  SET_INCIDENT_EXPERIENCE_LIST_COLUMNS_PREFS,
  SET_RESOURCE_LIST_COLUMNS_PREFS,
  SET_MAP_PREFS
};



// WEBPACK FOOTER //
// ./src/redux/config/types.js